import React from 'react'

export default function WherePage () {
  return (
    <div>
        <h1>WherePage</h1>
        <p>Here our location <a href='/'>Fetch our position</a></p>
    </div>
  )
}
